import { HiUsers, HiShieldCheck, HiKey } from "react-icons/hi2";
import CustomTabs from "../ui/CustomTabs/CustomTabs";

const iconStyle = { width: 16, height: 16 };
const RBACManagementTabs = ({ activeTab, onTabChange, tabCounts }) => {
  const RbacTabs = [
    {
      value: "permissions",
      label: "Permissions",
      icon: <HiKey style={iconStyle} />,
    },
    {
      value: "roles",
      label: "Roles",
      icon: <HiShieldCheck style={iconStyle} />,
    },
    {
      value: "users",
      label: "User Assignment",
      icon: <HiUsers style={iconStyle} />,
    },
  ];
  return (
    <CustomTabs
      tabs={RbacTabs}
      value={activeTab}
      onChange={onTabChange}
      tabCounts={tabCounts}
      grow={true}
    />
  );
};

export default RBACManagementTabs;
